import { appFetch } from './http'
import { apiUrl } from './native'

let token: string | null = null
let inflight: Promise<string> | null = null

export async function getCsrfToken(force = false): Promise<string> {
  if (token && !force) return token
  // Dedup concurrent callers onto one /auth/csrf fetch. On a forced refetch
  // (stale token after a 419) drop the old token first so a racing force=false
  // caller can't read it during the await window.
  if (force) token = null
  if (inflight) return inflight
  inflight = appFetch(apiUrl('/auth/csrf'), {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  })
    .then((r) => r.json())
    .then((j) => {
      token = j.csrfToken as string
      return token
    })
    .finally(() => {
      inflight = null
    })
  return inflight
}

export function clearCsrfToken(): void {
  token = null
  inflight = null
}
